import ApiBaseURL from "../../utils/config";
import ApiList from "../../utils/apiList";
import { GetUserAccessToken } from "../../utils/helper";

export const PremiumCalculator = async (formData) => {
  const response = await ApiBaseURL.post(
    ApiList.apiPremiumCalculator,
    formData,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};

export const GetPreviousPolicyStatusWithDetails = async (policyId) => {
  const response = await ApiBaseURL.get(
    ApiList.apiGetPreviousPolicyStatusWithDetails + "?PolicyId=" + policyId,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Content-Type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};


export const GetPDFPolicyNo = async (formData) => {
  const response = await ApiBaseURL.post(ApiList.apiGetPDFPolicyNo, formData, {
    headers: {
      Authorization: "Bearer " + GetUserAccessToken(),
      "Access-Control-Allow-Origin": "*",
      "Content-type": "application/json; charset=UTF-8",
    },
  });
  return response.data;
};

export const registerProposal = async (formData) => {
  const response = await ApiBaseURL.post(
    ApiList.apiRegisterProposal,
    formData,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};

export const eSewaPayment = async (formData) => {
  const response = await ApiBaseURL.post(
    ApiList.eSewaPaymentCheckout,
    formData,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};

export const generatePolicy = async (formData) => {
  const response = await ApiBaseURL.post(ApiList.apiGeneratePolicy, formData, {
    headers: {
      Authorization: "Bearer " + GetUserAccessToken(),
      "Access-Control-Allow-Origin": "*",
      "Content-type": "application/json; charset=UTF-8",
    },
  });
  return response.data;
};

export const policyPaper = async (formData) => {
  const response = await ApiBaseURL.get(ApiList.apiGetPDFPolicyNo + formData, {
    headers: {
      Authorization: "Bearer " + GetUserAccessToken(),
      "Access-Control-Allow-Origin": "*",
      "Content-type": "application/json; charset=UTF-8",
    },
  });
  return response.data;
};

export const riderPaper = async (id, rider) => {

  const url = `${ApiList.apiGetPDFRiderPaper}${id}&rider=${rider}`;
  
  const response = await ApiBaseURL.get(url, {
    headers: {
      Authorization: "Bearer " + GetUserAccessToken(),
      "Access-Control-Allow-Origin": "*",
      "Content-type": "application/json; charset=UTF-8",
    },
  });
  return response.data;
};
export const generateReceipt = async (formData) => {
  const response = await ApiBaseURL.get(
    ApiList.apiGenerateReceipt + "?PolicyNo=" + formData.PolicyNo,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};

export const termInsuranceRequiredDetailsList = async (formData) => {
  const response = await ApiBaseURL.post(
    ApiList.apiTermInsuranceRequiredDetailsList,
    formData,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};

export const sunLifeTermInsuranceDetails = async (formData) => {
  const response = await ApiBaseURL.post(
    ApiList.apiSunLifeTermInsuranceDetails,
    formData,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};

export const getProposalForEdit = async (formData) => {
  const response = await ApiBaseURL.get(
    ApiList.apiGetProposal + "?id=" + formData,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};

export const getTermLifePremium = async (formData) => {
  const response = await ApiBaseURL.post(
    ApiList.apiRegisterProposal,
    formData,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};

export const termPolicyIssued = async (formData) => {
  const response = await ApiBaseURL.post(
    ApiList.apiSunLifeTermPolicyIssued,
    formData,
    {
      headers: {
        Authorization: "Bearer " + GetUserAccessToken(),
        "Access-Control-Allow-Origin": "*",
        "Content-type": "application/json; charset=UTF-8",
      },
    }
  );
  return response.data;
};
